<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <!-- <div
    id="customer-list-view"
    class="data-list-container vs-con-loading__container"
    v-if="config.gocheckin_feature == 1"
  > -->
    <div
    id="customer-list-view"
    class="data-list-container vs-con-loading__container"
    v-if="1"
  >
    <!-- <vs-breadcrumb :items="items" class="mb-6"></vs-breadcrumb> -->
    <div class="flex flex-wrap-reverse justify-between flex-wrap align-center">
      <div class="vx-breadcrumb mb-6">
        <ul class="flex flex-wrap items-center">
          <li class="inline-flex items-end">
            <router-link to="/after-login">
              <feather-icon
                icon="HomeIcon"
                svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
              />
            </router-link>
            <span class="breadcrumb-separator mx-2 mr-1">
              <feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" />
            </span>
          </li>
          <li class="inline-flex items-end">
            <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Customer</span>
          </li>
        </ul>
      </div>

      <vs-button class="gradient gradient-primary no-shadow px-4 py-3 export-btn mb-5" @click="exportCustomer">
        <img src="../../assets/images/excel.png" class="excel-icon mr-2" />
        Export
      </vs-button>
    </div>
    <div v-if="isLoaded && chartInfo != {} && chartInfo.all != 0 && !config.hide_customer_statistic" class="mb-base">
      <vx-card class="shadow-xs customer-chart-card shadow-md">
        <vs-customer-chart :customerList="customersData" @CustomerChartLoadComplete="customerChartLoadComplete"></vs-customer-chart>
      </vx-card>
    </div>

    <vs-table ref="table" :max-items="itemsPerPage" :data="customersList">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex button-add-del">
          <transition name="list">
            <vs-button
              type="border"
              color="danger"
              class="text-base gradient gradient-danger no-shadow"
              @click="popupActive=true"
              v-show="$store.getters['customerList/customerHasSelected']"
            >Delete selected</vs-button>
          </transition>

          <vs-popup
            class="holamundo delete-customer"
            title="Delete Customer"
            :active.sync="popupActive"
          >
            <div class="text-center">
                <h3>Do you want to delete these customers?</h3>
                <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                <vs-button class="mr-6 align-center delete-responsive" @click="deleteCustomer">Delete</vs-button>
                <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="closePopup">Cancel</vs-button>
                </div>
            </div>
          </vs-popup>
        </div>

        <!-- ITEMS PER PAGE -->
        <div class="sm:flex sm:w-auto w-full">
          <date-picker class="last-visited-date-picker" range :format="date_format_string" v-model="date_filter" range-separator="  to  " type="date" :editable="false" clearable placeholder="Last visited date range" @change="selectDate"></date-picker>
          <vs-dropdown
            vs-trigger-click
            class="cursor-pointer item-per-page-dropdown"
            v-if="customersData._meta.totalCount > 0 && !config.hide_customer_statistic"
          >
            <div
              class="px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ customersData._meta.totalCount - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : customersData._meta.totalCount }} of {{ customersData._meta.totalCount }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu style="width: 80px">
              <vs-dropdown-item
                v-for="(item, i) in options"
                :key="i"
                @click="changeItemsPerPage(currentPage = 1, itemsPerPage=item)"
                v-model="itemsPerPage"
              >
                <span
                  class="w-full flex justify-between"
                  :class="{'text-primary': itemsPerPage == item}"
                >
                  {{item}}
                  <feather-icon
                    icon="CheckIcon"
                    svgClasses="h-3 w-3 ml-2"
                    v-if="itemsPerPage == item"
                  />
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <vs-dropdown vs-trigger-click class="cursor-pointer
           filter-dropdown">
            <div
              class="px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2">{{filter.title}}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu style="width: 120px">
              <vs-dropdown-item
                v-for="(item, i) in filterOptions"
                :key="i"
                v-model="filter"
                @click="filterType(item)"
              >
                <span
                  class="w-full flex justify-between"
                  :class="{'text-primary': filter.id == item.id}"
                >
                  {{item.title}}
                  <feather-icon
                    icon="CheckIcon"
                    svgClasses="h-3 w-3 ml-2"
                    v-if="filter.id == item.id"
                  />
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <vs-dropdown vs-trigger-click class="cursor-pointer
           filter-dropdown source-filter-dropdown">
            <div
              class="px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2" v-if="currentSource.id">{{ currentSource.title }}</span>
              <span class="text-grey mr-2" v-else>Source filter</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu style="width: 120px">
              <vs-dropdown-item
                v-for="(item, i) in sourceOptions"
                :key="i"
                v-model="currentSource"
                @click="filterSource(item)"
              >
                <span
                  class="w-full flex justify-between"
                  :class="{'text-primary': currentSource.id == item.id}"
                >
                  {{item.title}}
                  <feather-icon
                    icon="CheckIcon"
                    svgClasses="h-3 w-3 ml-2"
                    v-if="currentSource.id == item.id"
                  />
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <div class="con-input-search vs-table--search">
            <input
              type="text"
              class="input-search vs-table--search-input"
              @keyup="searchCustomer"
              placeholder="Search customer"
              v-model="search"
            />
            <i class="vs-icon notranslate icon-scale material-icons null">search</i>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th class="text-center">
          <vs-checkbox v-model="isCheckAll" @click="checkAll(isCheckAll)"></vs-checkbox>
        </vs-th>
        <vs-th sort-key="full_name">
          <div class="text-uppercase" @click="cur_sort_type='full_name', sort()">Name</div>
        </vs-th>
        <vs-th>
          <div class="text-uppercase">Type</div>
        </vs-th>
        <vs-th sort-key="visit_count">
          <div class="text-uppercase" @click="cur_sort_type='visit_count', sort()">Visit count</div>
        </vs-th>
        <vs-th sort-key="last_visited">
          <div class="text-uppercase" @click="cur_sort_type='last_visited', sort()">Last visited</div>
        </vs-th>
        <vs-th>
          <div class="text-uppercase">Life time point</div>
        </vs-th>
        <vs-th>
          <div class="text-uppercase">Current point</div>
        </vs-th>
        <vs-th sort-key="is_send_sms">
          <div class="text-uppercase">Send sms</div>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody id="customer-list-table" class="vs-con-loading__container">
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            @click.native="editData(tr), updateActiveCustomer(tr)"
            class="rounded-10 shadow-md"
            :class="{'is-selected' : tr.status}"
          >
            <vs-td>
              <vs-checkbox :value="tr.status" @click.stop="changeStatus(tr)" :key="tr.id"></vs-checkbox>
            </vs-td>
            <vs-td>
              <div class="user-name font-medium truncate flex">
                <vs-avatar
                  size="large"
                  :text="StringHelper.changeFormatAvatar(tr.full_name)"
                  class="text-2xl"
                  style="min-width: 50px;"
                />
                <div class="flex flex-col ml-3 justify-around truncate">
                  <span class="font-bold truncate">{{ tr.full_name }}</span>
                  <span>
                    <feather-icon icon="PhoneIcon" svgClasses="w-4 h-4 stroke-current" />
                    {{StringHelper.phoneNumberFormat(tr.phone)}}
                  </span>
                </div>
              </div>
            </vs-td>

            <vs-td>
              <!-- <vs-alert :color="getMemberTypeColor(tr.type)" class="text-center">{{tr.type}}</vs-alert> -->
              <div class="flex-center">
                <vs-alert
                  :color="getMemberTypeColor(tr.type)"
                  class="flex align-center justify-center member-type-alert"
                >{{tr.type}}</vs-alert>
              </div>
            </vs-td>

            <vs-td>
              <p class="user-name font-medium truncate text-center">{{ tr.visit_count }}</p>
            </vs-td>

            <vs-td>
              <p class="user-name font-medium truncate text-center">{{ changeFormat(tr.last_visited) }}</p>
            </vs-td>

            <vs-td>
              <p
                class="user-name font-medium truncate text-center"
                v-if="tr.lifetime_point"
              >{{ tr.lifetime_point }}</p>
              <p class="user-name font-medium truncate text-center" v-else>0</p>
            </vs-td>

            <vs-td>
              <p
                class="user-name font-medium truncate text-center"
                v-if="tr.current_point"
              >{{ tr.current_point }}</p>
              <p class="user-name font-medium truncate text-center" v-else>0</p>
            </vs-td>

            <vs-td>
              <div class="flex-center" v-if="tr.is_send_sms == 1">
                <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-primary" />
              </div>
              <div class="flex-center" v-else>
                <feather-icon icon="XIcon" svgClasses="w-6 h-6 stroke-current text-danger" />
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <div v-if="isLoaded">
      <customer-popup-content
        :popupConfig="popupConfig"
        :activeCustomer="activeCustomer"
        @ClosePopup="closePopup"
        :key="modalKey"
        :currentPage="currentPage"
        :itemsPerPage="itemsPerPage"
        :search="search"
        :filter="filter"
      ></customer-popup-content>
    </div>
    <div v-if="customersData._meta.pageCount">
      <!-- <vs-pagination class="custom-pagination" :total="parseInt(customersData._meta.pageCount)" v-model="currentPage" @click.native="changePage(currentPage, itemsPerPage)"></vs-pagination> -->
      <custom-pagination
        class="custom-pagination"
        :totalPages="parseInt(customersData._meta.pageCount)"
        :currentPage="currentPage"
        @pageChanged="changePage"
        :key="page_key"
      ></custom-pagination>
    </div>
  </div>
  <div v-else>
    <vx-card>
      <h2>
        This is for Go Check In full version, please contact us for more info at
        <b>832-968-6668</b>
      </h2>
    </vx-card>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vSelect from "vue-select";
import { StringHelper } from "../../models/string_helper";
import { changeFormatWithDateTime, formatExportDateString, formatDateString } from '../../helper/datetimeHelper';
import FileDownload from'js-file-download';
import moment from 'moment';

export default {
  components: {
    "v-select": vSelect,
    DatePicker
  },
  // props: {
  //   dataChange: {
  //     type: Object
  //   }
  // },
  data() {
    let format_export_date_string = formatExportDateString();
    let date_format_string = formatDateString();
    return {
      search: "",
      arr_selected: [],
      // itemsPerPage: 10,
      isMounted: false,
      options: [10, 15, 20, 30, 50],
      filterOptions: [
        { id: 1, title: "All", name: "all" },
        { id: 2, title: "New", name: "new" },
        { id: 3, title: "At risk", name: "atrisk" },
        { id: 4, title: "Vip", name: "vip" },
        { id: 5, title: "Regular", name: "regular" },
        { id: 6, title: "Normal", name: "normal" },
        { id: 7, title: "Import", name: "import" },
        { id: 8, title: "Booking", name: "booking" }
      ],
      filter: { id: 1, title: "All", name: "all" },
      sourceOptions: [
        { id: 0, title: "All", value: "all" },
        { id: 1, title: "Google", value: "google" },
        { id: 2, title: "Facebook", value: "facebook" },
        { id: 3, title: "Website", value: "website" },
        { id: 4, title: "Instagram", value: "instagram" },
        { id: 5, title: "Other", value: "other" },
      ],
      currentSource: { id: 0, title: "All", value: "all" },

      // Data Popup
      addNewDataSidebar: false,
      activeCustomer: {},
      popupConfig: {
        isOpen: false
      },

      // pageInfo: {
      currentPage: 1,
      itemsPerPage: 10,
      //   search: ''
      // },
      changeItemPerPage: false,
      isLoaded: false,
      isPopupLoaded: false,
      modalKey: 0,
      popupActive: false,
      // currentPage: 1,
      isCheckAll: false,
      StringHelper,
      sort_key: {
        type: "id",
        key: 0
      },
      cur_sort_type: "id",
      abc: 0,
      items: [
        {
          title: "Home",
          url: "/",
          icon: "HomeIcon"
        },
        {
          title: "Customer",
          active: true
        }
      ],
      action_type: "",
      isOpenLoading: false,
      page_key: 0,
      loaded_data_num: 0,
      isEmptyList: false,
      format_export_date_string,
      date_format_string,
      date_filter: [null, null],
    };
  },
  watch: {
  //   dataChange: {
  //     immediate: true,
  //     deep: true,
  //     handler: function () {
  //       // if(this.dataChange) {
  //       //   console.log(this.dataChange.message);
  //       // }
  //       // if(this.dataChange && this.dataChange.message == 'afterInsert') {
  //       if(this.dataChange) {
  //         const obj = {
  //             keyword: this.search,
  //             page: this.currentPage,
  //             "per-page": this.itemsPerPage
  //         }
  //         this.$store.dispatch("customerList/GET_CUSTOMER_LIST", obj)
  //       }
  //     },
  //   }
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 2 || this.isEmptyList) {
          this.closeLoading(1);
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv(1);
        }
      }
    },
    config: {
      immediate: true,
      deep: true,
      handler() {
        if(this.config && this.config.gocheckin_feature == 0 || this.config.hide_customer_statistic == 1) {
          this.loaded_data_num = 2;
        }
      }
    }
    // customersList: {
    //   immediate: true,
    //   deep: true,
    //   handler() {
    //     // let ele = document.getElementById('test_id');
    //     let ele = document.querySelector('#customer-list-view .vs-table--tbody');
    //     if(ele) {
    //       // setTimeout(() => {
    //         ele.scrollTo({top: 0, behavior: 'smooth'})
    //       // }, 50);
    //     }
    //   }
    // }
  },
  methods: {
    exportCustomer() {
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.action_type = 'Export';

      this.$store.dispatch("customerList/EXPORT_MEMBER").then((res) => {
        FileDownload(res.data, `#${localStorage.getItem("domainId")}-member-${moment().format(this.format_export_date_string)}.xls`);
        this.closeLoading();
        this.$vs.notify({
          title: "Notification",
          text: "Export Member Success",
          color: "success",
          position: "top-right"
        });
      });
    },
    filterType(type) {
      this.filter = type;
      this.currentPage = 1;
      const obj = {
        page: this.currentPage,
        "per-page": this.itemsPerPage,
        // "keyword": this.search,
        type: this.filter.name,
        keyword: this.search
      };
      if (this.filter.id == 1) {
        delete obj.type;
      }
      if(this.date_filter && this.date_filter[0]) {
        obj.start_date = moment(this.date_filter[0]).format("YYYY-MM-DD");
        obj.end_date = moment(this.date_filter[1]).format("YYYY-MM-DD");
      }
      if(this.currentSource && this.currentSource.id) {
        obj.source = this.currentSource.value;
      }
      this.openLoadingInDiv();
      this.$store.dispatch("customerList/GET_CUSTOMER_LIST", obj).then(() => {
        this.closeLoading();
      }).catch(() => {
        this.closeLoading();
      });
    },
    filterSource(source) {
      this.currentSource = source;
      this.currentPage = 1;
      const obj = {
        page: this.currentPage,
        "per-page": this.itemsPerPage,
        // "keyword": this.search,
        type: this.filter.name,
        keyword: this.search
      };
      if (this.filter.id == 1) {
        delete obj.type;
      }
      if(this.date_filter && this.date_filter[0]) {
        obj.start_date = moment(this.date_filter[0]).format("YYYY-MM-DD");
        obj.end_date = moment(this.date_filter[1]).format("YYYY-MM-DD");
      }
      if(this.currentSource && this.currentSource.id) {
        obj.source = this.currentSource.value;
      }
      this.openLoadingInDiv();
      this.$store.dispatch("customerList/GET_CUSTOMER_LIST", obj).then(() => {
        this.closeLoading();
      }).catch(() => {
        this.closeLoading();
      });
    },
    openLoadingInDiv(type = 0) { // Not before loading
      if(type == 0) {
        this.$vs.loading({
          container: "#customer-list-table",
          scale: 0.8
        });
      } else {
        this.$vs.loading({
          container: "#app",
          scale: 0.8
        });
      }
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading(type);
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' customer failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: "danger",
            title: "Notification",
            text: this.action_type + " customer failed",
            acceptText: "OK"
          });
        }
      }, 10000);
      // setTimeout(() => {
      //   this.$vs.loading.close("#customer-list-table > .con-vs-loading");
      // }, 500);
    },
    closeLoading(type = 0) {
      if(type == 0) {
        this.$vs.loading.close("#customer-list-table > .con-vs-loading");
      }
      this.$vs.loading.close("#app > .con-vs-loading");
      this.isOpenLoading = false;
    },
    sort() {
      this.filter = { id: 1, title: "All", name: "all" };
      this.search = "";
      //  this.currentPage = 1;
      if (this.cur_sort_type == this.sort_key.type) {
        this.changeKey(this.sort_key.key);
      } else {
        this.sort_key.type = this.cur_sort_type;
        this.sort_key.key = 1;
      }
      let obj = {
        sort: this.getType(),
        page: this.currentPage,
        "per-page": this.itemsPerPage,
        search: this.search
      };
      if(this.date_filter && this.date_filter[0]) {
        obj.start_date = moment(this.date_filter[0]).format("YYYY-MM-DD");
        obj.end_date = moment(this.date_filter[1]).format("YYYY-MM-DD");
      }
      if(this.currentSource && this.currentSource.id) {
        obj.source = this.currentSource.value;
      }
      // console.log(obj)
      this.openLoadingInDiv();
      this.action_type = "Get list";
      this.$store.dispatch("customerList/GET_CUSTOMER_LIST", obj).then(() => {
        this.closeLoading();
        this.isCheckAll = false;
      });
    },
    changeKey(key) {
      if (key == 0) {
        // return 1;
        this.sort_key.key = 1;
        return;
      } else if (key == 1) {
        // return -1;
        this.sort_key.key = -1;
        return;
      } else if (key == -1) {
        // return 0;
        this.sort_key.key = 0;
        return;
      }
    },
    getType() {
      if (this.sort_key.key == 0) {
        return "-last_visited";
      } else if (this.sort_key.key == 1) {
        return this.sort_key.type;
      } else if (this.sort_key.key == -1) {
        return "-" + this.sort_key.type;
      }
    },
    changeFormat(date) {
      if(date) {
        return changeFormatWithDateTime(date);
      } else {
        return 'N/A';
      }
    },
    searchCustomer({ target }) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      // this.$vs.loading({
      //   container: "#app",
      //   scale: 0.8
      // });
      if (!this.isOpenLoading) {
        this.openLoadingInDiv();
      }

      this.timer = setTimeout(() => {
        this.search = target.value;
        this.currentPage = 1;
        const obj = {
          page: this.currentPage,
          "per-page": this.itemsPerPage,
          keyword: target.value,
          type: this.filter.name
        };
        if (this.filter.id == 1) {
          delete obj.type;
        }
        if(this.date_filter && this.date_filter[0]) {
          obj.start_date = moment(this.date_filter[0]).format("YYYY-MM-DD");
          obj.end_date = moment(this.date_filter[1]).format("YYYY-MM-DD");
        }
        if(this.currentSource && this.currentSource.id) {
          obj.source = this.currentSource.value;
        }
        this.action_type = "Search";
        this.$store.dispatch("customerList/GET_CUSTOMER_LIST", obj).then(() => {
          // this.$vs.loading.close("#app > .con-vs-loading");
          this.closeLoading();
          this.isCheckAll = false;
        });
      }, 500);
      // this.openLoadingInDiv();
      // this.search = target.value;
      // this.currentPage = 1;
      // const obj={
      //   page: this.currentPage,
      //   "per-page": this.itemsPerPage,
      //   // "full_name": target.value
      //   keyword: target.value,
      //   type: this.filter.name,
      // }
      // if(this.filter.id == 1) {
      //   delete obj.type
      // }
      // this.$store.dispatch('customerList/GET_CUSTOMER_LIST',obj).then(() => {
      //   this.closeLoading();
      //   this.isCheckAll = false;
      // })
    },
    checkAll(isCheckAll) {
      if (isCheckAll) {
        for (let i = 0; i < this.customersList.length; i++) {
          // this.customersList[i].status = false;
          this.changeStatus(this.customersList[i], false);
        }
      } else {
        for (let i = 0; i < this.customersList.length; i++) {
          // this.customersList[i].status = true;
          this.changeStatus(this.customersList[i], true);
        }
      }
    },
    changeStatus(customer, status) {
      let obj = {
        customer: customer,
        status: status == undefined ? "" : status
      };
      this.$store.dispatch("customerList/CHANGE_CUSTOMER_STATUS", obj);
    },
    changeStatusCheckbox(status) {
      // console.log(status)

      if (status == false) {
        this.isCheckAll = false;
      }
    },
    changePage(currentPage) {
      // this.isCheckAll = false;
      const obj = {
        sort: this.getType(),
        page: currentPage,
        "per-page": this.itemsPerPage,
        // "full_name": this.search
        keyword: this.search,
        type: this.filter.name
      };
      if (this.filter.id == 1) {
        delete obj.type;
      }
      if(this.date_filter && this.date_filter[0]) {
        obj.start_date = moment(this.date_filter[0]).format("YYYY-MM-DD");
        obj.end_date = moment(this.date_filter[1]).format("YYYY-MM-DD");
      }
      if(this.currentSource && this.currentSource.id) {
        obj.source = this.currentSource.value;
      }
      this.openLoadingInDiv();
      this.action_type = "Get list";
      this.$store.dispatch("customerList/GET_CUSTOMER_LIST", obj).then(() => {
        this.closeLoading();
        this.isCheckAll = false;
        this.page_key++;
        this.currentPage = currentPage;
        let ele = document.querySelector('#customer-list-view .vs-table--tbody');
        if(ele) {
          ele.scrollTo({top: 0, behavior: 'smooth'})
        }
      });
    },
    changeItemsPerPage(currentPage, itemsPerPage) {
      const obj = {
        sort: this.getType(),
        page: currentPage,
        "per-page": itemsPerPage,
        // "full_name": this.search
        keyword: this.search,
        type: this.filter.name
      };
      if (this.filter.id == 1) {
        delete obj.type;
      }
      if(this.date_filter && this.date_filter[0]) {
        obj.start_date = moment(this.date_filter[0]).format("YYYY-MM-DD");
        obj.end_date = moment(this.date_filter[1]).format("YYYY-MM-DD");
      }
      if(this.currentSource && this.currentSource.id) {
        obj.source = this.currentSource.value;
      }
      this.openLoadingInDiv();
      this.action_type = "Get list";
      this.$store.dispatch("customerList/GET_CUSTOMER_LIST", obj).then(() => {
        this.closeLoading();
        this.isCheckAll = false;
        this.currentPage = currentPage;
        this.page_key++;
      });
    },
    editData(data) {
      this.activeCustomer = data;
      this.popupConfig.isOpen = true;
    },
    getMemberTypeColor(member_type) {
      if (member_type == "new") return "success";
      if (member_type == "atrisk") return "warning";
      if (member_type == "vip") return "danger";
      if (member_type == "regular") return "primary";
      if (member_type == "booking") return "booking";
      if (member_type == "import") return "import";
      return "purple";
    },
    closePopup() {
      this.popupConfig.isOpen = false;
      this.popupActive = false;
    },
    updateActiveCustomer(customer) {
      this.modalKey++;
      this.activeCustomer = customer;
    },
    deleteCustomer() {
      let tempString = "";
      for (let i = 0; i < this.customersList.length; i++) {
        if (this.customersList[i].status) {
          if (tempString == "") {
            tempString = tempString + this.customersList[i].id;
          } else {
            tempString = tempString + "," + this.customersList[i].id;
          }
        }
      }
      const obj = {
        ids: tempString,
        page: this.currentPage,
        "per-page": this.itemsPerPage,
        // "full_name": this.search
        keyword: this.search,
        type: this.filter.name
      };
      if (this.filter.id == 1) {
        delete obj.type;
      }
      if(this.date_filter && this.date_filter[0]) {
        obj.start_date = moment(this.date_filter[0]).format("YYYY-MM-DD");
        obj.end_date = moment(this.date_filter[1]).format("YYYY-MM-DD");
      }
      if(this.currentSource && this.currentSource.id) {
        obj.source = this.currentSource.value;
      }
      this.openLoadingInDiv();
      this.action_type = "Delete";
      this.$store
        .dispatch("customerList/BULK_DELETE_CUSTOMERS", obj)
        .then(() => {
          this.closePopup();
          this.closeLoading();
          this.$vs.notify({
            title: "Notification",
            text: "Delete Customer Success",
            color: "danger",
            position: "top-right"
          });
          this.isCheckAll = false;
        });
    },
    customerChartLoadComplete() {
      this.loaded_data_num++;
    },
    selectDate() {
      this.currentPage = 1;
      const obj = {
        page: this.currentPage,
        "per-page": this.itemsPerPage,
        type: this.filter.name,
        keyword: this.search
      };
      if (this.filter.id == 1) {
        delete obj.type;
      }
      if(this.date_filter && this.date_filter[0]) {
        obj.start_date = moment(this.date_filter[0]).format("YYYY-MM-DD");
        obj.end_date = moment(this.date_filter[1]).format("YYYY-MM-DD");
      }
      if(this.currentSource && this.currentSource.id) {
        obj.source = this.currentSource.value;
      }
      this.openLoadingInDiv();
      this.$store.dispatch("customerList/GET_CUSTOMER_LIST", obj).then(() => {
        this.closeLoading();
      }).catch(() => {
        this.closeLoading();
      });
    }
  },
  computed: {
    // currentPage() {
    //   if (this.isMounted) {
    //     if (this.changeItemPerPage) {
    //       this.changeItemPerPage = false;
    //       this.$refs.table.currentx = 1;
    //     }
    //     return this.$refs.table.currentx;
    //   }
    //   return 0;
    // },

    customersList() {
      return this.$store.getters["customerList/customerList"];
    },
    customersData() {
      return this.$store.getters["customerList/customerData"];
    },
    chartInfo() {
      return this.$store.getters["customerList/chartInfo"];
    },
    config() {
      return this.$store.getters["auth/config"];
    },
    isInGermany() {
      return this.$store.getters["appSetting/isInGermany"]
    }
  },
  created() {
    const obj = {
      // "full_name": this.search,
      keyword: this.search,
      page: this.currentPage,
      "per-page": this.itemsPerPage
    };
    this.$store
      .dispatch("customerList/GET_CUSTOMER_LIST", obj)
      .then(() => {
        this.isLoaded = true;
        if(this.$store.getters["customerList/customerList"].length > 0) {
          this.updateActiveCustomer(
            this.$store.getters["customerList/customerList"][0]
          );
        } else {
          this.isEmptyList = true;
        }
        this.loaded_data_num++;
      })
      .catch(error => console.log(error));
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>
